import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// ⚠ Se importa de 'react-router', NUNCA de 'react-router-dom'. Ese paquete SIGUE existiendo
//    (7.18.2) y no está deprecado: un import equivocado no falla al instalar, mete una
//    segunda copia de React Router v7 en paralelo a la 8.x y revienta en runtime con
//    contextos de Router duplicados. Hay un no-restricted-imports para evitarlo.
import { BrowserRouter, Routes, Route } from 'react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './styles.css'
import { App } from './App.jsx'

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 10_000, retry: 1 } },
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
